import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#0B0F17] flex items-center justify-center p-6" data-testid="payment-cancel-page">
      <div className="max-w-md w-full text-center">
        <XCircle size={56} className="mx-auto text-slate-500 mb-4" />
        <h1 className="font-display font-black text-3xl mb-2">Payment cancelled.</h1>
        <p className="text-slate-400 text-sm mb-6">No charge was made.</p>
        <Link to="/feed" data-testid="cancel-back-feed" className="inline-block px-5 py-3 rounded-xl bg-rose-500 hover:bg-rose-400 text-white text-sm font-bold">
          Back to feed
        </Link>
      </div>
    </div>
  );
}
